export default "/fonts/vendor/@fontsource/fraunces/files/fraunces-latin-ext-300-normal.woff2?f6b2b69acda37f0a7f3858843c6fa027";